import * as graphql from '@treams/treams-network';

import BulkModal from './BulkModal';

export default function BulkRestoreUserModal(props: {
	users: graphql.User[];
	onDismiss: () => void;
}) {
	const [restore] = graphql.useRestoreUserMutation();

	return (
		<BulkModal
			name="bulkRestoreUser"
			users={props.users}
			onDismiss={props.onDismiss}
			apply={async (user) => {
				try {
					await restore({ variables: { input: { id: user.id } } });
				} catch (_) {}
			}}
		/>
	);
}
